import Decimal from 'decimal.js-light';

export const safeDecimal = (value?: number): Decimal => new Decimal(value || 0);